/**
 * 程序主入口
 * 创建时间：2017-02-22
 *   创建人：zhanlz
 */
//ES6新增方法bable编译插件
import 'babel-polyfill' 

import Vue from 'vue'
import App from 'src/App'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import routes from 'src/routes/router'
import Vuelidate from 'vuelidate'
import store from 'store/store'
import BaiduMap from 'vue-baidu-map'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

//响应式样式
import 'assets/plugins/bootstrap/css/bootstrap.min.css'
import 'assets/plugins/bootstrap/js/bootstrap.min'
//进度条样式
import 'assets/plugins/pace/pace.min'
//滚动插件
import 'assets/plugins/superslide/jquery.SuperSlide.2.1.1'

//动画效果
import 'assets/plugins/animate/animate.css'
//字体样式
import 'font-awesome-webpack'
//布局模板样式
import 'assets/project/css/style.css'
//自定义样式
import 'assets/project/css/fixation.css'
//页面样式
import 'assets/project/css/module.css'
//布局模板主题
import 'assets/project/css/layout-theme.css'
//页面主题
import 'assets/project/css/page-theme.css'
//表单验证样式
import 'assets/project/css/vuelidate.css'

//通知插件样式
import 'assets/plugins/toastr/toastr.min.css'  

//变化布局
$(window).bind("load resize", function () {
    if ($(this).width() < 769) {
        $('body').addClass('mini-navbar');
        $('.navbar-static-side').fadeIn();
    }
});

Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(Vuelidate)

//百度插件设置
Vue.use(BaiduMap,{
	ak: 'OWBpo196WwiDeqE8u0sRUMxV'
})

//路由属性配置
const router = new VueRouter({
	mode: 'history',
	routes
})
//全局路由钩子
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    	if (store.state.user.accesstoken!='') {
            next();
        }
        else {
            next({
                path: '/login',
                query: {redirect: to.fullPath}
            });
        }
  } else {
    next()
  }
})
//全局自定义指令
import directive from './static/directive.js'
Vue.use(directive)

//输入车牌号用的input
import VplateInput from 'components/common/VplateInput'
Vue.component('vplate-input', VplateInput)

//设置全局的timeout
//Vue.http.options.timeout = 10000;
//请求拦截器配置
Vue.http.interceptors.push((request, next) => {
	if (window.localStorage.getItem('accesstoken')) {
    	Vue.http.headers.common['access-token'] = window.localStorage.getItem('accesstoken')
  	}
  	next((response) => {
  		if(response.body.status===401){
  			store.dispatch('removeall');
			store.dispatch('removestorage')
			let timerName = store.state.user.tokentimer;
			clearInterval(timerName);
			store.dispatch('setstatus',"401")
			router.push("login");
  		}
        return response
    });
})

//页面刷新
function reflesh(){ 
	store.dispatch('removestorage')
} 
window.onbeforeunload = reflesh;

new Vue({
  el: '#app',
  router,
  store,
  components: { 
  	            //Login,
  				App }
})





// WEBPACK FOOTER //
// ./src/main.js